import { ScheduleDesviationRule, ScheduleDesviationRuleCreate } from './@types/ScheduleDesviationRuleModel';

export class ScheduleDesviationRepo {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getScheduleDesviations(): Promise<ScheduleDesviationRule[]> {
        try {
            const response = await this.httpService.get<TKResponse<ScheduleDesviationRule[]>>('/schedule_desviation_rules');
            return response.data
                .map((schedule_desviation: ScheduleDesviationRule) => ({
                    ...schedule_desviation,
                    id: schedule_desviation.schedule_desviation_rule_id,
                }))
                .sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener las schedule_desviation_rules:', error);
            throw error;
        }
    }
    async getScheduleDesviationById(scheduleDesviationId: number): Promise<ScheduleDesviationRule> {
        try {
            const response = await this.httpService.get<TKResponse<ScheduleDesviationRule>>(`/schedule_desviation_rules/${scheduleDesviationId}`);

            return { ...response.data, id: response.data.schedule_desviation_rule_id };
        } catch (error) {
            console.error('Error al obtener la schedule_desviation_rule por ID:', error);
            throw error;
        }
    }
    async createScheduleDesviation(body: ScheduleDesviationRuleCreate): Promise<{ data: ScheduleDesviationRule; status: number }> {
        try {
            const response = await this.httpService.post<TKResponse<ScheduleDesviationRule>, ScheduleDesviationRuleCreate>('/schedule_desviation_rules', { data: body });
            return { data: { ...response.data, id: response.data.schedule_desviation_rule_id }, status: 200 };
        } catch (error) {
            console.error('Error al crear la schedule_desviation_rule:', error);
            throw error;
        }
    }
    async duplicateScheduleDesviation(scheduleDesviationId: number, body: ScheduleDesviationRuleCreate): Promise<{ data: ScheduleDesviationRule; status: number }> {
        try {
            const response = await this.httpService.post<TKResponse<ScheduleDesviationRule>, ScheduleDesviationRuleCreate>(`/schedule_desviation_rules/${scheduleDesviationId}/duplicate`, {
                data: body,
            });
            return { data: { ...response.data, id: response.data.schedule_desviation_rule_id }, status: 200 };
        } catch (error) {
            console.error('Error al duplicar la schedule_desviation_rule:', error);
            throw error;
        }
    }
    async updateScheduleDesviation(scheduleDesviationId: number, body: ScheduleDesviationRuleCreate): Promise<{ data: ScheduleDesviationRule; status: number }> {
        try {
            const response = await this.httpService.patch<TKResponse<ScheduleDesviationRule>, ScheduleDesviationRuleCreate>(`/schedule_desviation_rules/${scheduleDesviationId}`, { data: body });
            return { data: { ...response.data, id: response.data.schedule_desviation_rule_id }, status: 200 };
        } catch (error) {
            console.error('Error al actualizar la schedule_desviation_rule:', error);
            throw error;
        }
    }
    async deleteScheduleDesviation(scheduleDesviationId: number): Promise<void> {
        try {
            await this.httpService.delete<void>(`/schedule_desviation_rules/${scheduleDesviationId}`);
        } catch (error) {
            console.error('Error al eliminar la schedule_desviation_rule:', error);
            throw error;
        }
    }
}
